export default async function dispatch({ action, payload }) {
  const [moduleName, method] = action.split('.');
  const targetModule = await this.get(moduleName);
  if (targetModule && targetModule[method]) {
    targetModule[method](payload);
  }
}



// WEBPACK FOOTER //
// ./src/components/dispatch.js